export { default as CustomResearchHtml } from './component';
